import { ExpressionPart } from "src/models/calculations/CalculationDetailsResult"
import { SavingStatus } from "src/models/common/SavingStatus"
import { ValidationError } from "../CalculationStep"
import { CalcBuilderComment } from "../CalcBuilderComment"

export interface PLITemplateType {
    value: string,
    description: string,
    group: string
}

export enum PLISectionEditMode {
    READ_ONLY = "READ_ONLY",
    EDITABLE = "EDITABLE"
}

export enum PLIStepType {
    STEP = "STEP",
    SECTION = "SECTION_METADATA",
    PLI = "PLI"
}

export interface BasePLIEntity {
    calculationNumber: string,
    createUser: string,
    createdDate: number,
    lastModifiedDate: number,
    lastModifiedUser: string,
    unsavedId?: string,
}

export interface PLIConfigMetadata extends BasePLIEntity {    
    pli: string, // Selected PLI template
    pliStatus: string,
    pliVersion: number
    isMissingConfiguration: boolean
}

export interface PLIConfig {
    isValid: boolean,
    name: string,
    description: string,
    templateType: PLITemplateType,
    sections: PLIConfigTemplateSection[]
}

export interface PLIConfigTemplateSection {
    error: string
    name: string,
    description: string,
    editMode: PLISectionEditMode,
    steps: PLIConfigStep[]
    isOverview: boolean
    showValues: boolean    
}

export interface PLIConfigStep extends BasePLIEntity {    
    description: string,
    expression: string,
    expressionTokens: Array<ExpressionPart>,
    expressionFormatted?: string,
    pliVersion: number,
    sectionName: string,
    sequence: number,
    stepId: string,
    valid: boolean,
    formulaEditorCaretPosition?: number,
    isBeingEdited: boolean,
    isNew: boolean,
    savingStatus: SavingStatus,
    visibleSequence?: string,
    validationErrors?: Array<ValidationError>,
    formulaOutput?: string,
    outputBreakdown?: string,
    value?: string,
    valueBreakdown?: string,
    descriptionHelp: string,
    isConfigurableStep: boolean,
    isDescriptionEditable: boolean,
    isValueEditable: boolean,
    hasComments: boolean
    comments: CalcBuilderComment[],
    isMarkupRate: boolean
}

export interface SaveSectionNamePayload {
    calculationNumber: string;
    oldStepDescription: string;
    newStepDescription: string;
}